<template>
  <div>
    <div class="has-text-centered p-md">
      <div class="">
        <transition name="component-fade" mode="out-in">
          <component :is="formView"
                     :query-params="$route.query"
                     @login="showLogin"
                     @loggedIn="redirect"
                     @forgetPassword="showForgetPassword"
                     @register="showRegister"
          >
          </component>
        </transition>
      </div>
    </div>

    <div class="has-text-centered p-md" v-if="$route.meta.schoolType === 'highschool'">
      <div class="container connexion-presentation">
        <div class="box">
          <div class="title has-text-weight-light is-3">
            <span>Les étapes qui vous attendent :</span>
          </div>
          <hr>
          <div>
            <div class="title has-text-weight-light is-4">
              <span>Vous pourrez créer votre profil ...</span>
            </div>

            <div class="has-text-centered">
              <img :src="'/img/connexion/1profil.png'" class="connexion-image" alt="profil">
            </div>
          </div>
          <!--                        <hr>
                                  <div>
                                      <div class="title has-text-weight-light is-4">
                                          <span>... choisir la formation qui vous intéresse ...</span>
                                      </div>
                                      <img :src="'/img/connexion/2formation.png'" class="connexion-image" alt="formation">
                                  </div>-->
          <hr>
          <div>
            <div class="title has-text-weight-light is-4">
              <span>... rédiger votre lettre de motivation ...</span>
            </div>
            <img :src="'/img/connexion/3motivation.png'" class="connexion-image" alt="motivation">
          </div>
          <hr>
          <div>
            <div class="title has-text-weight-light is-4">
              <span>... échanger quand vous le souhaitez avec nos conseillers.</span>
            </div>
            <img :src="'/img/connexion/4boitedialogue.png'" class="connexion-image" alt="dialogue">
          </div>

        </div>

      </div>
    </div>

    <div class="has-text-centered p-md" v-if="$route.meta.schoolType === 'boardingschool'">
      <div class="container connexion-presentation">
        <div class="box">
          <div class="title has-text-weight-light is-3">
            <span>Les étapes qui vous attendent :</span>
          </div>
          <hr>
          <div>
            <div class="title has-text-weight-light is-4">
              <span>Vous pourrez inscrire votre enfant ...</span>
            </div>

            <div class="has-text-centered">
              <img :src="'/img/connexion/etape-1-diderotmax-boarding-school-diderot.PNG'" class="connexion-image"
                   alt="profil">
            </div>
          </div>
          <hr>
          <div>
            <div class="title has-text-weight-light is-4">
              <span>... sélectionner la classe envisagée ...</span>
            </div>
            <img :src="'/img/connexion/etape-2-diderotmax-boarding-school-diderot.PNG'" class="connexion-image"
                 alt="formation">
          </div>
          <hr>
          <div>
            <div class="title has-text-weight-light is-4">
              <span>... remplir le dossier de candidature de votre enfant ...</span>
            </div>
            <img :src="'/img/connexion/etape-4-diderotmax-boarding-school-diderot.PNG'" class="connexion-image"
                 alt="motivation">
            <img :src="'/img/connexion/etape-5-diderotmax-boarding-school-diderot.PNG'" class="connexion-image"
                 alt="motivation">
          </div>
          <hr>
          <div>
            <div class="title has-text-weight-light is-4">
              <span>... échanger quand vous le souhaitez avec nos conseillers.</span>
            </div>
            <img :src="'/img/connexion/boite-dialogue-diderotmax-boarding-school-diderot.PNG'" class="connexion-image"
                 alt="dialogue">
          </div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import RegisterForm from './RegisterTrainingForm'
import SignInForm from './SignInForm.vue'
import ForgetPasswordForm from './ForgetPasswordForm.vue'
import {mapGetters} from 'vuex'

export default {
  props: ['queryParams'],
  components: {
    RegisterForm,
    SignInForm,
    ForgetPasswordForm
  },
  data() {
    return {
      formView: RegisterForm,
      login: true,
      register: false,
      forgetPassword: false
    }
  },
  methods: {
    isCandidate() {
      return this.userRoles && this.userRoles.indexOf('candidate') > -1
    },
    isAdmin() {
      return this.userRoles && this.userRoles.indexOf('admin') > -1
    },
    redirect: function () {
      this.loggedUser()
    },
    showRegister: function () {
      this.formView = RegisterForm
    },
    showLogin: function () {
      if (this.school) {
        switch (this.school.school_type) {
          case 'highschool':
            this.$router.push({name: 'highschool-connection', params: {school: this.$route.params.school}})
            break
          case 'boardingschool':
            this.$router.push({name: 'school-connection', params: {school: this.$route.params.school}})
            break
          case 'eschool':
            this.$router.push({name: 'eschool-connection', params: {school: this.$route.params.school}})
            break
          default:
            this.formView = SignInForm
        }
      }
    },
    showForgetPassword: function () {
      this.formView = ForgetPasswordForm
    },
    loggedUser: function () {
      if (this.isLoggedIn && this.isCandidate()) {
        this.$router.push('mon-compte')
      }
      if (this.isLoggedIn && this.isAdmin()) {
        this.$router.push({path: '/admin'})
      }
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
      userRoles: 'auth/getRoles',
      schoolBySlug: 'organization/getSchoolBySlug',
    }),
    school() {
      return this.schoolBySlug(this.$route.params.school)
    },
  },
  beforeMount() {
    this.loggedUser()
  },
}
</script>
<style scoped>
.connexion-presentation {
  max-width: 48rem;
}

.connexion-presentation .is-3 {
  font-size: 2.1rem;
}

.connexion-presentation .is-4 {
  font-size: 1.8rem;
  font-style: italic;
}

.connexion-image {
  max-height: 35rem;
}
</style>
